interface IEnterpriseLogo {
    logoUrl: string;
    init: Function;
}

class EnterpriseLogoController implements IEnterpriseLogo {
    logoUrl: string;
    static $inject = ["authConfig"];
    enterpriseId: string;
    constructor(private authConfig) { }
    init = () => {
        this.logoUrl = this.authConfig.redirectUri + "/resources/" + this.enterpriseId + "/Branding/logo.svg";
        // console.log(this.logoUrl);
        // this.logoUrl = "/src/client/assets/images/mgh-logo.svg";
    }
}

function enterpriseLogo(): ng.IDirective {
    return {
        restrict: 'E',
        template: `
                        <div class="enterprise-logo">
                            <img ng-src="{{ entLogoVm.logoUrl }}" ng-if="!!entLogoVm.logoUrl" class="{{entLogoVm.logoSize}}"></img>
                        </div>
                        `,
        replace: true,
        controller: EnterpriseLogoController,
        controllerAs: 'entLogoVm',
        scope: true,
        bindToController: {
            'enterpriseId': '@',
            'logoSize': '@'
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEnterpriseLogo): void => {
            controller.init();

        }
    };
}

angular.module('eCareVault.common.directives').directive('enterpriseLogo', enterpriseLogo);
